<template>
  <h1>Results</h1>
    <div id="final-summary-table">
      <div id="final-summary-headings" class="form-section no-border">
        <summary-col>
        </summary-col>
        <data-col>
          <data-row>
            <label></label>
            <div class="data-summary-wrapper">
              <div class="data-summary">Current Situation</div>
            </div>
            <div class="data-summary-wrapper lq-proj-heading">
              <div class="data-summary">Using LifeQuote</div>
            </div>
          </data-row>
        </data-col>
      </div>
      <div class="form-section">
        <summary-col>
          <h3>Mortgages</h3>
        </summary-col>
        <data-col>
          <data-row class="with-variables">
            <label>Average Number of Mortgage Sign Ups</label>
            <div class="data-summary-wrapper">
              <div class="data-summary">{{ monthlyAvgMortgageSignup }}</div>
            </div>
            <div class="data-summary-wrapper lq-proj">
              <div class="data-summary">{{ projectedMonthlyAvgMortgageSignup }}</div>
            </div>
            <div class="variable-control">
              <div id="percentageCaseIncrease">
                <input class="data-input" v-model="percentageGain"/>
                <span>% increase using LQ <img class="img-help" src="../assets/icons/help-pink.svg" @click="togglePercenageGain"/></span>
                <Transition name="fade">
                  <div class="help-text" v-if="showPercentageGainHelp">Advisers who use LifeQuote Administration write 20% more protection cases every month. Amend the % increase according to your business.</div>
                </Transition>
              </div>
            </div>
          </data-row>
          <data-row>
            <label>Average Application Fee</label>
            <div class="data-summary-wrapper">
              <div class="data-summary">{{ appFee }}</div>
            </div>
            <div class="data-summary-wrapper lq-proj">
              <div class="data-summary">{{ appFee }}</div>
            </div>
          </data-row>
          <data-row>
            <label>Monthly Mortgage Income</label>
            <div class="data-summary-wrapper">
              <div class="data-summary">{{ currentMortgageIncome }}</div>
            </div>
            <div class="data-summary-wrapper lq-proj">
              <div class="data-summary">{{ projectedMortgageIncome }}</div>
            </div>
          </data-row>
        </data-col>
      </div>
      <div class="form-section">
        <summary-col>
            <h3>Protection</h3>
        </summary-col>
        <data-col>
          <data-row>
            <label>Protection Cases</label>
            <div class="data-summary-wrapper">
              <div class="data-summary">{{ lifeCover }}</div>
            </div>
            <div class="data-summary-wrapper lq-proj">
              <div class="data-summary">{{ projectedLifeCoverCases }}</div>
            </div>
          </data-row>
          <data-row>
            <label>Average Premium</label>
            <div class="data-summary-wrapper">
              <div class="data-summary">{{ avgLifePremium }}</div>
            </div>
            <div class="data-summary-wrapper lq-proj">
              <div class="data-summary">{{ avgLifePremium }}</div>
            </div>
          </data-row>
          <data-row>
            <label>Average Commission</label>
            <div class="data-summary-wrapper">
              <div class="data-summary">{{ avgLifeCommission }}</div>
            </div>
            <div class="data-summary-wrapper lq-proj">
              <div class="data-summary">{{ avgLifeCommission }}</div>
            </div>
          </data-row>
          <data-row>
            <label class="section-summary-label">Monthly Protection Income</label>
            <div class="data-summary-wrapper">
              <div class="data-summary">{{ currentLifeIncome }}</div>
            </div>
            <div class="data-summary-wrapper lq-proj">
              <div class="data-summary">{{ projectedLifeIncome }}</div>
            </div>
          </data-row>
        </data-col>
      </div>
      <div class="form-section">
        <summary-col>
            <h3>Buildings & Contents</h3>
        </summary-col>
        <data-col>
          <data-row>
            <label>Buildings & Contents Cases</label>
            <div class="data-summary-wrapper">
              <div class="data-summary">{{ bins }}</div>
            </div>
            <div class="data-summary-wrapper lq-proj">
              <div class="data-summary">{{ projectedBinsCases }}</div>
            </div>
          </data-row>
          <data-row>
            <label>Average Premium</label>
            <div class="data-summary-wrapper">
              <div class="data-summary">{{ avgBinsPremium }}</div>
            </div>
            <div class="data-summary-wrapper lq-proj">
              <div class="data-summary">{{ avgBinsPremium }}</div>
            </div>
          </data-row>
          <data-row>
            <label>Average Commission</label>
            <div class="data-summary-wrapper">
              <div class="data-summary">{{ avgBinsCommission }}</div>
            </div>
            <div class="data-summary-wrapper lq-proj">
              <div class="data-summary">{{ avgBinsCommission }}</div>
            </div>
          </data-row>
          <data-row>
            <label class="section-summary-label">Monthly Buillding & Contents Income</label>
            <div class="data-summary-wrapper">
              <div class="data-summary">{{ currentBinsIncome }}</div>
            </div>
            <div class="data-summary-wrapper lq-proj">
              <div class="data-summary">{{ projectedBinsIncome }}</div>
            </div>
          </data-row>
        </data-col>
      </div>
      <div class="form-section">
        <summary-col>
          <h3>Estimated Monthly Overheads</h3>
        </summary-col>
        <data-col>
          <data-row>
            <label>Monthly Overheads</label>
            <div class="data-summary-wrapper">
              <div class="data-summary">{{ overheads }}</div>
            </div>
            <div class="data-summary-wrapper lq-proj">
              <div class="data-summary">{{ overheads }}</div>
            </div>
          </data-row>
          <data-row class="with-variables">
            <label>Lapse Provisions @ {{lapseRate}}%</label>
            <div class="data-summary-wrapper">
              <div class="data-summary">{{ currentLapseProvisions }}</div>
            </div>
            <div class="data-summary-wrapper lq-proj">
              <div class="data-summary">{{ projectedLapseProvisions }}</div>
            </div>
            <div class="variable-control">
              <div id="percentageLapsed">
                <input class="data-input" v-model="lapseRate"/>
                <span>% lapsed policies <img class="img-help" src="../assets/icons/help-pink.svg" @click="toggleLapsed"/></span>
                <Transition name="fade">
                  <div class="help-text" v-if="showLapsedHelp">We estimate 25% of protection policies lapse every year. Amend the % lapse rate according to your business.</div>
                </Transition>
              </div>
            </div>
          </data-row>
          <data-row>
            <label>LifeQuote Fee</label>
            <div class="data-summary-wrapper">
              <div class="data-summary">£0</div>
            </div>
            <div class="data-summary-wrapper lq-proj">
              <div class="data-summary">{{ lifeQuoteFee }}</div>
            </div>
          </data-row>
          <data-row>
            <label>Total Monthly Overheads</label>
            <div class="data-summary-wrapper">
              <div class="data-summary">{{ overheads }}</div>
            </div>
            <div class="data-summary-wrapper lq-proj">
              <div class="data-summary">{{ projectedOverheads }}</div>
            </div>
          </data-row>
        </data-col>
      </div>
      <div class="form-section">
        <summary-col>
          <h3>Annual Summary</h3>
        </summary-col>
        <data-col>
          <data-row>
            <label>Total Income</label>
            <div class="data-summary-wrapper">
              <div class="data-summary">{{ currentAnnualIncome }}</div>
            </div>
            <div class="data-summary-wrapper lq-proj">
              <div class="data-summary">{{ projectedAnnualIncome }}</div>
            </div>
          </data-row>
          <data-row>
            <label>Total Costs</label>
            <div class="data-summary-wrapper">
              <div class="data-summary">{{ currentAnnualCosts }}</div>
            </div>
            <div class="data-summary-wrapper lq-proj">
              <div class="data-summary">{{ projectedAnnualCosts }}</div>
            </div>
          </data-row>
          <data-row>
            <label>Total Lapsed Policies</label>
            <div class="data-summary-wrapper">
              <div class="data-summary">{{ currentAnnualLapseProvisions }}</div>
            </div>
            <div class="data-summary-wrapper lq-proj">
              <div class="data-summary">{{ projectedAnnualLapseProvisions }}</div>
            </div>
          </data-row>
          <data-row>
            <label>Profit</label>
            <div class="data-summary-wrapper">
              <div class="data-summary">{{ currentAnnualProfit }}</div>
            </div>
            <div class="data-summary-wrapper lq-proj">
              <div class="data-summary">{{ projectedAnnualProfit }}</div>
            </div>
          </data-row>
        </data-col>
      </div>
      <div id="form-section-conclusion">
        <summary-col>
          <h3></h3>
        </summary-col>
        <data-col>
          <data-row>
            <div class="label-wrapper">
              <label>LifeQuote Uplift</label><label v-if="companyName !== ''"><br/> for {{ companyName }}</label>
            </div>
            <div id="lq-uplift" class="data-summary-wrapper lq-proj">
              <div class="data-summary">{{ lqUplift }}</div>
            </div>
          </data-row>
        </data-col>
      </div>
  </div>
  <div id="form-footer">
    <div class="button-wrapper back-button-wrapper">
      <BtnBack title="Back"/>
    </div>
  </div>
  
</template>

<script>
var formatter = new Intl.NumberFormat('en-GB', {
  style: 'currency',
  currency: 'GBP',
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
});

import BtnBack from './BtnBack.vue'
export default {
  data () {
    return {
      showPercentageGainHelp: false,
      showLapsedHelp: false
    }
  },
  props: {
  },
  methods:{
    togglePercenageGain() {
      this.showPercentageGainHelp = !this.showPercentageGainHelp;
   },
    toggleLapsed() {
      this.showLapsedHelp = !this.showLapsedHelp;
   }
  },
  computed: {
      monthlyAvgMortgageSignup: {
        get () {
          return this.$store.state.currentRevenues.mortgages.monthlyAvgSignup
        }
      },
      projectedMonthlyAvgMortgageSignup: {
        get () {
          return Math.round(this.$store.state.currentRevenues.mortgages.monthlyAvgSignup * this.$store.getters.multiplier * 100) / 100
        }
      },
      appFee: {
        get () {
          return formatter.format(this.$store.state.currentRevenues.mortgages.appFee)
        }
      },
      percentageGain:{
        get () {
          return this.$store.state.percentageGain
        },
        set (value) {
          this.$store.commit('setPercentageGain', value)
        }
      },
      lapseRate:{
        get () {
          return this.$store.state.lapseRate
        },
        set (value) {
          this.$store.commit('setLapseRate', value)
        }
      },
      lifeCover: {
        get () {
          return this.$store.state.currentRevenues.life.cases
        }
      },
      projectedLifeCoverCases: {
        get () {
          return this.$store.state.currentRevenues.life.cases > 0 ? Math.round(this.$store.state.currentRevenues.life.cases * 1.2 * 100) / 100 : 0
        }
      },
      avgLifePremium: {
        get () {
          return formatter.format(this.$store.state.currentRevenues.life.avgPremium)
        }
      },
      avgLifeCommission: {
        get () {
          return formatter.format(this.$store.state.currentRevenues.life.avgCommission)
        }
      },
      bins: {
        get () {
          return this.$store.state.currentRevenues.bins.cases
        }
      },
      projectedBinsCases: {
        get () {
          return this.$store.state.currentRevenues.bins.cases > 0 ? Math.round(this.$store.state.currentRevenues.bins.cases * 1.2 * 100) / 100 : 0
        }
      },
      avgBinsPremium: {
        get () {
          return formatter.format(this.$store.state.currentRevenues.bins.avgPremium)
        }
      },
      avgBinsCommission: {
        get () {
          return formatter.format(this.$store.state.currentRevenues.bins.avgCommission)
        }
      },
      overheads: {
        get (){
          return formatter.format(this.$store.getters.totalOverheads)
        }
      },
      lifeQuoteFee: {
        get () {
          return formatter.format(this.$store.getters.projectedTotalCost)
        }
      },
      projectedOverheads:{
        get () {
          return formatter.format(this.$store.getters.totalOverheads + this.$store.getters.projectedTotalCost)
        }
      },
      currentMortgageIncome: {
        get () {
          return formatter.format(this.$store.getters.currentMortgageIncome)
        }
      },  
      currentLifeIncome: {
        get () {
          return formatter.format(this.$store.getters.currentLifeIncome)
        }
      },
      currentBinsIncome: {
        get () {
          return formatter.format(this.$store.getters.currentBinsIncome)
        }
      },
      currentLapseProvisions:{
        get () {
          return formatter.format(this.$store.getters.currentLapseProvisions)
        }
      },
      currentAnnualIncome:{
        get () {
          return formatter.format(this.$store.getters.currentAnnualIncome)
        }
      },
      currentAnnualProfit:{
        get () {
          return formatter.format(this.$store.getters.currentAnnualProfit)
        }
      },
      currentAnnualCosts:{
        get () {
          return formatter.format(this.$store.getters.currentAnnualCosts)
        }
      },
      currentAnnualLapseProvisions:{
        get () {
          return formatter.format(this.$store.getters.currentAnnualLapseProvisions)
        }
      },
      projectedMortgageIncome: {
        get () {
          return formatter.format(this.$store.getters.projectedMortgageIncome)
        }
      },  
      projectedLifeIncome: {
        get () {
          return formatter.format(this.$store.getters.projectedLifeIncome)
        }
      },
      projectedBinsIncome: {
        get () {
          return formatter.format(this.$store.getters.projectedBinsIncome)
        }
      },
      projectedLapseProvisions:{
        get () {
          return formatter.format(this.$store.getters.projectedLapseProvisions)
        }
      },
      projectedAnnualIncome:{
        get () {
          return formatter.format(this.$store.getters.projectedAnnualIncome)
        }
      },
      projectedAnnualCosts:{
        get () {
          return formatter.format(this.$store.getters.projectedAnnualCosts)
        }
      },
      projectedAnnualLapseProvisions:{
        get () {
          return formatter.format(this.$store.getters.projectedAnnualLapseProvisions)
        }
      },
      projectedAnnualProfit:{
        get () {
          return formatter.format(this.$store.getters.projectedAnnualProfit )
        }
      },
      lqUplift:{
        get () {
          return formatter.format(this.$store.getters.projectedAnnualProfit - this.$store.getters.currentAnnualProfit )
        }
      },
      companyName: {
        get(){
          return this.$store.getters.companyName
        }
      }
      
  },
  components: {
    BtnBack
  }
}
</script>
